import React, { Component } from 'react';
import Select2 from 'react-select2-wrapper';
import { browserHistory, Link } from 'react-router';
import { Field, reduxForm, change } from 'redux-form';
// import moment from 'moment';
import moment from 'moment-timezone';
import Header from '../../components/Header';
import SaveProductError from '../../components/Models/SaveProductError';
import ManuallyProductWarnModal from '../../components/Models/ManuallyProductWarnModal';
import ClearAllProducts from '../../components/Models/ClearAllProducts';
import withUser from '../../common/withUser';
import withNotify from '../../common/withNotify';
import withProducts from '../../common/withProducts';
import withScanner from '../../common/withScanner';
import withLotScanner from '../../common/withLotScanner';
import withGoBack from '../../common/withGoBack';
import withOtherCharge from '../../common/withOtherCharge';
import withOnline from '../../common/withOnline';
import withLoader from '../../common/withLoader';
import withTableName from '../../common/withTableName';
import {
  renderField,
  required
} from '../../helpers/form-validations';
import {
  getHospitalByCustomerNo,
  getInventoryType,
  getProduct,
  getTableCaseByCaseId,
  getVhnPpcValue,
  insertComplianceApp,
  updateTableCaseByPrimaryId,
  updateTableWiseCaseByCaseId,
  getProductDescriptionById,
} from '../../utils/db';
import {
  addProduct,
  removeProduct,
  updateProduct,
  updateCase,
  uploadDgr,
  addComplianceAppData,
  listSingleCase
} from '../../utils/utils';
import {
  onGoBack,
  sortData,
  SERVER_TIMEZONE,
  create_UUID,
  Fcm_Token,
} from '../../common/globals';
import Bugsnag from '../../helpers/bugsnag';
import NoProductModal from '../../components/Models/NoProductModal';
import ACMProductGoBackModal from '../../components/Models/ACMProductGoBackModal';
import CaseChangesNoLonger from '../../components/Models/CasesChangesNoLonger';
import SaveProductModal from '../../components/Models/SaveProductModal';
import DgrRequiredModal from '../../components/Models/DgrRequired';
import withTeam from '../../common/withTeam';
import VhnPpcModal from '../../components/Models/VhnPpcModal';
import VelysLogoOrange from '../../assets/images/VELYS-Logo-Orange.png';
import VrasPpcModal from '../../components/Models/VrasPpcModal';
import withReadOnlyProductNotes from '../../common/withReadOnlyProductNotes';
// import TakePhotoModal from '../../components/Models/TakePhotoModal';
import FFFModal from '../../components/Models/FFFModal';
import ProductNotSave from '../../components/Models/ProductNotSave';
import SaveProductWastedError from '../../components/Models/SaveProductWastedError';
import ProductListIcon from '../../assets/images/list.png';
import SearchByProduct from './components/SearchByProduct';
import DeleteProductModal from '../../components/Models/DeleteProductModal';
import withBrowserDetect from '../../common/withBrowserDetect';

class AddEditProduct extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isScanProduct: true,
      isScanLot: true,
      selectedInventoryType: '',
      productInventoryType: [],
      products: [],
      inventoryCount: 0,
      caseRes: {},
      manualProduct: {},
      manualLot: {},
      lotCount: 0,
      productCount: 0,
      dgrsCount: 0,
      velysUsed: '',
      NeedPrice: false,
      hospitalNeedPrice: false,
      PriceSheet: false,
      isFFFVisable: false,
      isFFFActivate: '',
      territoryData: false,
      productData: {},
      errorMessage: '',
      showSearchProducts: false,
      showSearchProductKey: '',
      deleteProductKey: '',
      dgrRedirectStatus: false,
      dgrAddedStatus: false,
    };
    this.saveProductErrortModal = null;
    this.manuallyProductWarnModal = null;
    this.noProductModal = null;
    this.setBackModal = null;
    this.caseChangesNoLonger = null;
    this.saveProductModalModal = null;
    this.clearAllProductsModal = null;
    this.dgrRequiredModal = null;
    this.vhnPpcModal = null;
    this.vrasPpcModal = null;
    // this.takePhotoModal = null;
    this.FFFModal = null;
    this.ProductNotSaveModal = null;
    this.saveProductWastedErrortModal = null;
    this.deleteProductModalModal = null;
    this.uploadRef = React.createRef();
    this.pollingInterval = null;
  }

  componentDidMount() {
    try {
      this.saveProductErrortModal = new window.bootstrap.Modal(window.$('#saveProductError'));
      this.manuallyProductWarnModal = new window.bootstrap.Modal(window.$('#manuallyProductWarnModal'));
      this.noProductModal = new window.bootstrap.Modal(window.$('#noProductModal'));
      this.setBackModal = new window.bootstrap.Modal(
        window.$('#acmProductGoBackModal')
      );
      this.caseChangesNoLonger = new window.bootstrap.Modal(window.$('#CaseChangesNoLongerModal'));
      this.saveProductModalModal = new window.bootstrap.Modal(window.$('#saveProductModalModal'));
      this.clearAllProductsModal = new window.bootstrap.Modal(window.$('#clearAllProductsModal'));
      this.dgrRequiredModal = new window.bootstrap.Modal(window.$('#dgrRequiredModal'));
      this.vhnPpcModal = new window.bootstrap.Modal(window.$('#vhnPpcModalModal'));
      this.vrasPpcModal = new window.bootstrap.Modal(window.$('#vrasPpcModal'));
      // this.takePhotoModal = new window.bootstrap.Modal(window.$('#takePhotoModal'));
      this.FFFModal = new window.bootstrap.Modal(window.$('#FFFModal'));
      this.ProductNotSaveModal = new window.bootstrap.Modal(window.$('#ProductNotSaveModal'));
      this.saveProductWastedErrortModal = new window.bootstrap.Modal(window.$('#saveProductWastedError'));
      this.deleteProductModalModal = new window.bootstrap.Modal(window.$('#deleteProductModalModal'));
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onProductSaveYes = async () => {
    try {
      const {
        goBack, params: { id }, tableName, setProducts, setGoBack
      } = this.props;

      // const caseDetails = await getCaseByCaseId(id);
      // const caseRes = await getTableCaseByCaseId(id, tableName);

      const caseDetail = await getTableCaseByCaseId(id, tableName);

      const compareValue = await this.compareUpdatedValue();
      const newArrayOfObj = caseDetail.case_sets.map(({
        CasePlanId: CasePlanID,
        ...rest
      }) => ({
        CasePlanID,
        ...rest
      }));
      caseDetail.selectedSets = newArrayOfObj;
      caseDetail.ProductSubmitted = '0';
      caseDetail.ProductNotes = (caseDetail.ProductNotes === '' || caseDetail.ProductNotes === null) ? 'No products used' : caseDetail.ProductNotes;

      if (caseDetail.case_products.length === 0 && caseDetail.case_dgrs.length === 0) {
        caseDetail.DGRUpload = '0';
      }
      if (compareValue) {
        caseDetail.ProductSubmitted = '0';
      }

      caseDetail.CaseTime = this.state.caseRes.CaseTime;

      await updateCase(caseDetail);
      await updateTableCaseByPrimaryId(id, caseDetail, tableName);
      setProducts([]);
      // await updateCaseByPrimaryId(id, caseDetail);
      this.noProductModal.hide();

      const { dgrAddedStatus } = this.state;
      if (dgrAddedStatus) {
        goBack.push(`/manage-case/${id}/products/add`);
        setGoBack(goBack);
        browserHistory.push(`/manage-case/${id}/products/dgr`);
      } else {
        // onGoBack(goBack);
        if (goBack.length === 5 && goBack[goBack.length - 4] === '/missing-dgr') {
          setGoBack(['/billing', '/missing-dgr']);
          browserHistory.push(`/manage-case/${id}`);
        } else if (goBack.length === 4 && goBack[goBack.length - 3] === '/missing-dgr') {
          setGoBack(['/billing', '/missing-dgr']);
          browserHistory.push(`/manage-case/${id}`);
        } else if (goBack.length === 4 && goBack[goBack.length - 1].indexOf(`/manage-case/${id}/products/list`) > -1) {
          setGoBack(['/manage-cases', `/manage-case/${id}`]);
          onGoBack(goBack.splice(goBack.length - 2, 1));
        } else if (goBack.length === 4 && goBack[goBack.length - 2].indexOf('manage-cases/filter-cases') > -2) {
          onGoBack(goBack.splice(goBack.length - 2, 1));
        } else if (goBack.length === 3 && goBack[goBack.length - 1].indexOf('manage-cases/filter-cases') > -1) {
          setGoBack(['/manage-cases', '/manage-cases/filter']);
          onGoBack(goBack);
        } else if (goBack.length === 4 && goBack[goBack.length - 2].indexOf(`manage-case/${id}`) > -2) {
          onGoBack(goBack.splice(goBack.length - 2, 1));
        } else if (goBack.length === 3 && goBack[goBack.length - 2].indexOf(`/manage-case/${id}/products`) > -1) {
          setGoBack(['/manage-cases']);
          browserHistory.push('/manage-cases');
        } else if (goBack.length === 2 && goBack[goBack.length - 1].indexOf(`/manage-case/${id}/products`) > -1) {
          setGoBack(['/manage-cases']);
          browserHistory.push('/manage-cases');
        } else if (goBack.length === 3 && goBack[goBack.length - 3] === '/manage-cases') {
          setGoBack(['/manage-cases']);
          browserHistory.push(`/manage-case/${id}`);
        } else if (goBack.length === 3 && goBack[goBack.length - 1] === `/manage-case/${id}/products/add`) {
          setGoBack(['/manage-cases']);
          browserHistory.push(`/manage-case/${id}`);
        } else if (goBack.length === 3 && goBack[goBack.length - 1].indexOf(`manage-case/${id}`) > -1) {
          setGoBack(['/billing', '/missing-dgr']);
          onGoBack(goBack);
        } else if (goBack.length >= 2 && goBack[goBack.length - 2].indexOf(`manage-case/${id}`) > -1) {
          // TODO Remove all state and set only /manage-cases
          setGoBack(['/manage-cases']);
          browserHistory.push(`/manage-case/${id}`);
        } else if (goBack.length === 2 && goBack[goBack.length - 1].indexOf(`/manage-case/${id}/products/add`) > -1) {
          setGoBack(['/manage-cases']);
          browserHistory.push('/manage-cases');
        } else if (goBack.length === 2 && goBack[goBack.length - 1].indexOf(`/manage-case/${id}/products/list`) > -1) {
          setGoBack(['/manage-cases']);
          browserHistory.push('/manage-cases');
        } else if (goBack.length === 2) {
          onGoBack(goBack);
        } else {
          browserHistory.push('/manage-cases');
        }
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onProductSaveNo = () => {
    try {
      this.noProductModal.hide();
      // const { dgrAddedStatus } = this.state;
      // if (dgrAddedStatus) {
      //   const {
      //     params: { id }, goBack, setGoBack,
      //   } = this.props;

      //   goBack.push(`/manage-case/${id}/products/add`);
      //   setGoBack(goBack);
      //   browserHistory.push(`/manage-case/${id}/products/dgr`);
      // }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onCancel = () => {
    try {
      const { setProducts } = this.props;
      this.saveProductModalModal.hide();
      setProducts([]);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSubmit = async () => {
    try {
      const { products, dgrAddedStatus } = this.state;
      const {
        params: { id }, setProducts, online, setLoader, goBack, tableName, setGoBack,
        user: {
          name,
          selectedTeam: { timezone }
        },
        team: { dgrRequired }
      } = this.props;

      const compareValue = await this.compareUpdatedValue();
      let inventoryCount = 0;
      const productsClone = [...products];

      productsClone.pop();
      productsClone.map((item) => {
        if (item.RepInventoryType === null || item.RepInventoryType === '') {
          inventoryCount += 1;
        }
      });

      this.setState({ inventoryCount });
      if (inventoryCount > 0) {
        this.saveProductErrortModal.show();
        this.saveProductModalModal.hide();
      } else {
        const caseDetail = await getTableCaseByCaseId(id, tableName);
        if (caseDetail && caseDetail.DGR === '1') {
          this.caseChangesNoLonger.show();
          return;
        }

        const {
          CaseScheduleID, CaseDate, CaseTime, CustomerNo, CustomerName, SurgeonName,
          PatientID, ProcedureType, CaseType, Side, Comments,
          RepNotes, ProductNotes,
          ProductSubmitted, RepPONumber, Submitted, CoverRep, DGRUpload,
          MRN, Gender, Age, ACMPlannedParts, ACMSelectedParts, Height, Weight, selectedSets,
          case_dgrs, ...partialObject
        } = caseDetail;

        const subset = {
          CaseScheduleID,
          CaseDate,
          CaseTime,
          CustomerNo,
          CustomerName,
          SurgeonName,
          PatientID,
          ProcedureType,
          CaseType,
          Side,
          Comments,
          RepNotes,
          ProductNotes,
          ProductSubmitted,
          RepPONumber,
          Submitted,
          CoverRep,
          ChangeRep: name,
          DGRUpload,
          MRN,
          Gender,
          Age,
          ACMPlannedParts,
          ACMSelectedParts,
          Height,
          Weight,
          selectedSets,
          case_dgrs
        };

        const newArrayOfObj = partialObject.case_sets.map(({
          CasePlanId: CasePlanID,
          ...rest
        }) => ({
          CasePlanID,
          ...rest
        }));

        subset.selectedSets = newArrayOfObj;
        subset.ProductNotes = (subset.ProductNotes === '' || subset.ProductNotes === null || subset.ProductNotes === 'No products used') ? '' : subset.ProductNotes;

        if (online) {
          setLoader(true);

          // const productAddPromiseAll = productsClone.map(
          //   // eslint-disable-next-line no-async-promise-executor
          //   async (product, key) => new Promise(async (resolve) => {
          //     try {
          //       if (!product.hasOwnProperty('CaseProductsID')) {
          //         // Add product
          //         product.RepCaseNo = caseDetail.RepCaseNo;
          //         product.ProductRep = name;
          //         product.ScanDate = moment().tz(timezone).format('YYYY-MM-DD HH:mm:ss.SSS');
          //         // product.ScanDate = moment().format('YYYY-MM-DD HH:mm:ss.SSS');
          //         product.DeviceID = Fcm_Token;
          //         product.AppGeneratedID = create_UUID();
          //         product.ProductCaseNo = caseDetail.RepCaseNo;
          //         await addProduct(product).then(async (response) => {
          //           if (response.result === 'failure') {
          //             this.setState({
          //               errorMessage: response.message
          //             });

          //             throw new Error('Failed to update product');
          //           }

          //           if (response.hasOwnProperty('data')) {
          //             const updatedScanDate = moment(moment.tz(
          //               response.data.ScanDate, 'YYYY-MM-DD HH:mm:ss.SSS', SERVER_TIMEZONE
          //             )).tz(timezone).format('YYYY-MM-DD HH:mm:ss.SSS');
          //             // const updatedScanDate =
          //             // moment(response.data.ScanDate).format('YYYY-MM-DD HH:mm:ss.SSS');
          //             productsClone[key] = response.data;
          //             productsClone[key].ScanDate = updatedScanDate;

          //             subset.case_products = productsClone;
          //             if (compareValue) {
          //               // subset.Submitted = '0';
          //               subset.ProductSubmitted = '0';
          //             }

          //             if (subset.case_dgrs.length === 0 && dgrRequired > 0) {
          //               subset.DGRUpload = '1';
          //             }

          //             await updateCase(subset);
          //             // Set product into local
          //             // caseDetail.DGRUpload = '1';
          //             if (caseDetail.case_dgrs.length === 0 && dgrRequired > 0) {
          //               caseDetail.DGRUpload = '1';
          //             }

          //             caseDetail.case_products = productsClone;
          //             if (compareValue) {
          //               // caseDetail.Submitted = '0';
          //               caseDetail.Synced =
          // (caseDetail.Synced === '1' ? '0' : caseDetail.Synced);
          //               caseDetail.ProductSubmitted = '0';
          //             }

          //             await updateTableCaseByPrimaryId(id, caseDetail, tableName);
          //           }
          //         });
          //       } else {
          //         // Edit product
          //         const caseProductId = product.CaseProductsID;
          //         delete product.CaseProductsID;
          //         if (JSON.stringify(product)) {
          //           await updateProduct(caseProductId, product).then(async (response) => {
          //             if (response.result === 'failure') {
          //               this.setState({
          //                 errorMessage: response.message
          //               });

          //               throw new Error('Failed to update product');
          //             }

          //             if (response.hasOwnProperty('data')) {
          //               productsClone[key] = response.data;
          //               productsClone[key].ScanDate = moment(moment.tz(
          //                 response.data.ScanDate, 'YYYY-MM-DD HH:mm:ss.SSS', SERVER_TIMEZONE
          //               )).tz(timezone).format('YYYY-MM-DD HH:mm:ss.SSS');
          //               // productsClone[key].ScanDate =
          //               // moment(response.data.ScanDate).format('YYYY-MM-DD HH:mm:ss.SSS');
          //               // caseDetail.DGRUpload = '1';

          //               subset.case_products = productsClone;
          //               if (compareValue) {
          //                 // subset.Submitted = '0';
          //                 subset.ProductSubmitted = '0';
          //               }

          //               if (subset.case_dgrs.length === 0 && dgrRequired > 0) {
          //                 subset.DGRUpload = '1';
          //               }

          //               await updateCase(subset);

          //               if (compareValue) {
          //                 // caseDetail.Submitted = '0';
          //                 caseDetail.Synced =
          // (caseDetail.Synced === '1' ? '0' : caseDetail.Synced);
          //                 caseDetail.ProductSubmitted = '0';
          //               }

          //               if (caseDetail.case_dgrs.length === 0 && dgrRequired > 0) {
          //                 caseDetail.DGRUpload = '1';
          //               }

          //               caseDetail.case_products = productsClone;
          //               await updateTableCaseByPrimaryId(id, caseDetail, tableName);
          //             }
          //           });
          //         }
          //       }
          //       resolve(true);
          //     } catch (error) {
          //       setLoader(false);
          //       this.ProductNotSaveModal.show();
          //     }
          //   })
          // );

          // try {
          //   await Promise.all(productAddPromiseAll);
          //   setLoader(false);
          // } catch (e) {
          //   setLoader(false);
          //   this.ProductNotSaveModal.show();
          // }

          try {
            if (productsClone.length > 0) {
              await Promise.all(productsClone.map(
                // eslint-disable-next-line no-async-promise-executor
                async (product, key) => {
                  try {
                    if (!product.hasOwnProperty('CaseProductsID')) {
                      // Add product
                      product.RepCaseNo = caseDetail.RepCaseNo;
                      product.ProductRep = name;
                      product.ScanDate = moment().tz(timezone).format('YYYY-MM-DD HH:mm:ss.SSS');
                      product.DeviceID = Fcm_Token;
                      product.AppGeneratedID = create_UUID();
                      product.ProductCaseNo = caseDetail.RepCaseNo;
                      await addProduct(product).then(async (response) => {
                        if (response.result === 'failure') {
                          this.setState({
                            errorMessage: response.message
                          });

                          throw new Error('Failed to update product');
                        }

                        if (response.hasOwnProperty('data')) {
                          const updatedScanDate = moment(moment.tz(
                            response.data.ScanDate, 'YYYY-MM-DD HH:mm:ss.SSS', SERVER_TIMEZONE
                          )).tz(timezone).format('YYYY-MM-DD HH:mm:ss.SSS');

                          productsClone[key] = response.data;
                          productsClone[key].ScanDate = updatedScanDate;

                          // subset.case_products = productsClone;

                          if (compareValue) {
                            subset.ProductSubmitted = '0';
                          }

                          if (subset.case_dgrs.length === 0 && dgrRequired > 0) {
                            subset.DGRUpload = '1';
                          }

                          await updateCase(subset);

                          if (caseDetail.case_dgrs.length === 0 && dgrRequired > 0) {
                            caseDetail.DGRUpload = '1';
                          }

                          caseDetail.case_products = productsClone;
                          if (compareValue) {
                            caseDetail.Synced = (caseDetail.Synced === '1' ? '0' : caseDetail.Synced);
                            caseDetail.ProductSubmitted = '0';
                          }

                          await updateTableCaseByPrimaryId(id, caseDetail, tableName);
                        }
                      });
                    } else {
                      // Edit product
                      const caseProductId = product.CaseProductsID;
                      delete product.CaseProductsID;
                      if (JSON.stringify(product)) {
                        await updateProduct(caseProductId, product).then(async (response) => {
                          if (response.result === 'failure') {
                            this.setState({
                              errorMessage: response.message
                            });

                            throw new Error('Failed to update product');
                          }

                          if (response.hasOwnProperty('data')) {
                            productsClone[key] = response.data;
                            productsClone[key].ScanDate = moment(moment.tz(
                              response.data.ScanDate, 'YYYY-MM-DD HH:mm:ss.SSS', SERVER_TIMEZONE
                            )).tz(timezone).format('YYYY-MM-DD HH:mm:ss.SSS');

                            // subset.case_products = productsClone;
                            if (compareValue) {
                              subset.ProductSubmitted = '0';
                            }

                            if (subset.case_dgrs.length === 0 && dgrRequired > 0) {
                              subset.DGRUpload = '1';
                            }

                            await updateCase(subset);

                            if (compareValue) {
                              caseDetail.Synced = (caseDetail.Synced === '1' ? '0' : caseDetail.Synced);
                              caseDetail.ProductSubmitted = '0';
                            }

                            if (caseDetail.case_dgrs.length === 0 && dgrRequired > 0) {
                              caseDetail.DGRUpload = '1';
                            }

                            caseDetail.case_products = productsClone;
                            await updateTableCaseByPrimaryId(id, caseDetail, tableName);
                          }
                        });
                      }
                    }

                    return true;
                  } catch (error) {
                    setLoader(false);
                    this.ProductNotSaveModal.show();
                  }
                }
              ));
            }
          } catch (e) {
            Bugsnag.notify(e);
          }

          await this._updateWastedProductNotes();

          const caseRes = await getTableCaseByCaseId(id, tableName);
          this.setState({ caseRes });

          setLoader(false);
          if (caseDetail.case_products.length === 0) {
            this.noProductModal.show();
            return;
          }
        } else {
          // If user offline
          setLoader(true);
          if (productsClone.length > 0) {
            const productAddPromiseAll = productsClone.map(
              // eslint-disable-next-line no-async-promise-executor
              async (product) => new Promise(async (resolve) => {
                if (!product.hasOwnProperty('CaseProductsID')) {
                  // Add product
                  product.RepCaseNo = caseDetail.RepCaseNo;
                  product.ProductRep = name;
                  product.ScanDate = moment().tz(timezone).format('YYYY-MM-DD HH:mm:ss.SSS');
                  // product.ScanDate = moment().format('YYYY-MM-DD HH:mm:ss.SSS');
                  product.DeviceID = Fcm_Token;

                  // Set product into local
                  caseDetail.DGRUpload = '1';
                  caseDetail.case_products = productsClone;
                  if (compareValue) {
                    // caseDetail.Submitted = '0';
                    caseDetail.Synced = (caseDetail.Synced === '1' ? '0' : caseDetail.Synced);
                    caseDetail.ProductSubmitted = '0';
                  }
                  caseDetail.Sync = 1;
                  await updateTableCaseByPrimaryId(id, caseDetail, tableName);
                }
                resolve(true);
              })
            );
            await Promise.all(productAddPromiseAll);
          }
          setLoader(false);
          if (caseDetail.case_products.length === 0) {
            this.noProductModal.show();
            return;
          }
        }

        this.saveProductErrortModal.hide();
        this.manuallyProductWarnModal.hide();
        this.noProductModal.hide();
        this.setBackModal.hide();
        this.caseChangesNoLonger.hide();
        this.saveProductModalModal.hide();
        this.clearAllProductsModal.hide();
        this.dgrRequiredModal.hide();
        this.vhnPpcModal.hide();
        this.vrasPpcModal.hide();
        this.FFFModal.hide();
        this.ProductNotSaveModal.hide();
        this.saveProductWastedErrortModal.hide();
        this.deleteProductModalModal.hide();

        // Navigate back to manage-cases
        if (!dgrAddedStatus) {
          // console.log('goBack', goBack);
          // console.log(goBack[goBack.length - 1]);
          // console.log(goBack[goBack.length - 1].indexOf(`/manage-case/${id}/products/list`));
          // Redirect from manage-cases
          if (goBack.length === 5 && goBack[goBack.length - 4] === '/missing-dgr') {
            setGoBack(['/billing', '/missing-dgr']);
            browserHistory.push(`/manage-case/${id}`);
          } else if (goBack.length === 4 && goBack[goBack.length - 3] === '/missing-dgr') {
            setGoBack(['/billing', '/missing-dgr']);
            browserHistory.push(`/manage-case/${id}`);
          } else if (goBack.length === 4 && goBack[goBack.length - 1].indexOf(`/manage-case/${id}/products/list`) > -1) {
            setGoBack(['/manage-cases', `/manage-case/${id}`]);
            onGoBack(goBack.splice(goBack.length - 2, 1));
          } else if (goBack.length === 4 && goBack[goBack.length - 2].indexOf('manage-cases/filter-cases') > -2) {
            onGoBack(goBack.splice(goBack.length - 2, 1));
          } else if (goBack.length === 3 && goBack[goBack.length - 1].indexOf('manage-cases/filter-cases') > -1) {
            setGoBack(['/manage-cases', '/manage-cases/filter']);
            onGoBack(goBack);
          } else if (goBack.length === 4 && goBack[goBack.length - 2].indexOf(`manage-case/${id}`) > -2) {
            onGoBack(goBack.splice(goBack.length - 2, 1));
          } else if (goBack.length === 3 && goBack[goBack.length - 2].indexOf(`/manage-case/${id}/products`) > -1) {
            setGoBack(['/manage-cases']);
            browserHistory.push('/manage-cases');
          } else if (goBack.length === 2 && goBack[goBack.length - 1].indexOf(`/manage-case/${id}/products`) > -1) {
            setGoBack(['/manage-cases']);
            browserHistory.push('/manage-cases');
          } else if (goBack.length === 3 && goBack[goBack.length - 3] === '/manage-cases') {
            setGoBack(['/manage-cases']);
            browserHistory.push(`/manage-case/${id}`);
          } else if (goBack.length === 3 && goBack[goBack.length - 1] === `/manage-case/${id}/products/add`) {
            setGoBack(['/manage-cases']);
            browserHistory.push(`/manage-case/${id}`);
          } else if (goBack.length === 3 && goBack[goBack.length - 1].indexOf(`manage-case/${id}`) > -1) {
            setGoBack(['/billing', '/missing-dgr']);
            onGoBack(goBack);
          } else if (goBack.length >= 2 && goBack[goBack.length - 2].indexOf(`manage-case/${id}`) > -1) {
            // TODO Remove all state and set only /manage-cases
            setGoBack(['/manage-cases']);
            browserHistory.push(`/manage-case/${id}`);
          } else if (goBack.length === 2 && goBack[goBack.length - 1].indexOf(`/manage-case/${id}/products/add`) > -1) {
            setGoBack(['/manage-cases']);
            browserHistory.push('/manage-cases');
          } else if (goBack.length === 2 && goBack[goBack.length - 1].indexOf(`/manage-case/${id}/products/list`) > -1) {
            setGoBack(['/manage-cases']);
            browserHistory.push('/manage-cases');
          } else if (goBack.length === 2) {
            onGoBack(goBack);
          } else {
            browserHistory.push('/manage-cases');
          }
        } else {
          setProducts([]);
          this.setState({ dgrAddedStatus: false });

          const productData = [];
          const caseDetails = await getTableCaseByCaseId(id, tableName);
          if (caseDetails && caseDetails.case_products.length > 0) {
            caseDetails.case_products.map((item) => {
              productData.push(Object.assign(item, {
                isScanProduct: true,
                isScanLot: true,
                isOtherCharge: true,
              }));
            });
            this.setState({ products: productData });
            setProducts(productData);
            await this.updateProducts();
          }

          goBack.push(`/manage-case/${id}/products/add`);
          setGoBack(goBack);
          browserHistory.push(`/manage-case/${id}/products/dgr`);
        }
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  compareUpdatedValue = async () => {
    try {
      const { products } = this.state;
      const {
        params: { id }, tableName
      } = this.props;
      const caseRes = await getTableCaseByCaseId(id, tableName);
      let oldSets = [];
      oldSets = caseRes.case_products.map(
        ({
          ProductNo,
          ProductDescription,
          RepCaseNo,
          RepInventoryType,
          LotNo,
          UnitPrice,
          CaseProductsID
        }) => ({
          ProductNo,
          ProductDescription,
          RepCaseNo,
          RepInventoryType,
          LotNo,
          UnitPrice,
          CaseProductsID
        })
      );
      let newSets = [];
      newSets = products.map(
        ({
          ProductNo,
          ProductDescription,
          RepCaseNo,
          RepInventoryType,
          LotNo,
          UnitPrice,
          CaseProductsID
        }) => ({
          ProductNo,
          ProductDescription,
          RepCaseNo,
          RepInventoryType,
          LotNo,
          UnitPrice,
          CaseProductsID
        })
      );
      const productsClone = [...newSets];
      productsClone.pop();
      if (JSON.stringify(productsClone) === JSON.stringify(oldSets)) {
        return false;
      }
      return true;
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onProductClick = (key) => {
    try {
      const {
        params, setScanner
      } = this.props;
      setScanner({ key, scanType: 'product' });
      browserHistory.push(`/manage-case/${params.id}/products/scan`);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onLotClick = (key) => {
    try {
      const { params, setScanner } = this.props;
      setScanner({ key, scanType: 'lot' });
      browserHistory.push(`/manage-case/${params.id}/products/scan`);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onChangeProductInventoryType = (value, index) => {
    try {
      const { setProducts } = this.props;
      const { products } = this.state;
      products[index] = Object.assign(products[index], { RepInventoryType: value });
      setProducts(products);
      this.setState({ products });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickScanProduct = async (index) => {
    try {
      const { products } = this.state;

      if (products[index].isScanProduct) {
        (!products[index].isScanProduct) ? window.$(`#ProductNo${index}`).blur() : window.$(`#ProductNo${index}`).focus();
      }

      setTimeout(() => {
        this._onScrollToBottom();
      }, 700);

      if (products.length - 1 === index) {
        products[index] = Object.assign(
          products[index],
          { isScanProduct: !products[index].isScanProduct }
        );
        this.setState({ products });
      } else if (index > -1) {
        this.setState({ deleteProductKey: index });
        this.deleteProductModalModal.show();
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickOtherScanLot = async (index) => {
    try {
      const {
        params: { id }, online, tableName, notify, setLoader
      } = this.props;
      const { products } = this.state;

      const caseRes = await getTableCaseByCaseId(id, tableName);
      if (online) {
        setLoader(true);
        if (caseRes !== null) {
          const caseData = (await listSingleCase(caseRes.CaseScheduleID)).data;
          const { case_products } = caseData[0];

          if (typeof case_products !== 'undefined' && case_products !== null && case_products.length > 0) {
            const singleProduct = products[index];
            const productImport = case_products.filter((item) => (
              item.CaseProductsID === singleProduct.CaseProductsID && item.Imported === '1'
            )).length > 0;
            if (productImport) {
              setLoader(false);
              notify({ type: 'error', message: 'This product has already been processed. Please contact your local office to unlock for editing.' });
              return;
            }
          }
        }
        setLoader(false);
      }

      products[index] = Object.assign(products[index], {
        isScanLot: !products[index].isScanLot,
        RepInventoryType: null,
        LotNo: null,
        isOtherCharge: false,
        UnitPrice: null
      });
      this.setState({ products });
      await this.updateProducts();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickScanLot = async (index) => {
    try {
      const {
        params: { id }, online, tableName, notify, setLoader
      } = this.props;
      const { products } = this.state;

      const caseRes = await getTableCaseByCaseId(id, tableName);
      if (online) {
        setLoader(true);
        if (caseRes !== null) {
          const caseData = (await listSingleCase(caseRes.CaseScheduleID)).data;
          const { case_products } = caseData[0];

          if (typeof case_products !== 'undefined' && case_products !== null && case_products.length > 0) {
            const singleProduct = products[index];
            const productImport = case_products.filter((item) => (
              item.CaseProductsID === singleProduct.CaseProductsID && item.Imported === '1'
            )).length > 0;
            if (productImport) {
              setLoader(false);
              notify({ type: 'error', message: 'This product has already been processed. Please contact your local office to unlock for editing.' });
              return;
            }
          }
        }
        setLoader(false);
      }

      if (products[index].isScanLot) {
        window.$(`#LotNo${index}`).focus();
      }

      products[index] = Object.assign(products[index], {
        isScanLot: !products[index].isScanLot,
        RepInventoryType: (products[index].LotNo !== null && products[index].isScanLot)
          ? null : products[index].RepInventoryType,
        LotNo: null,
      });

      this.setState({ products });
      await this.updateProducts();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onGoBack = () => {
    try {
      const { goBack, setGoBack } = this.props;
      goBack.push(window.location.pathname);
      setGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onProductNotes = () => {
    try {
      const { params: { id }, setReadOnlyProductNotes } = this.props;
      setReadOnlyProductNotes(false);
      this._onGoBack();
      browserHistory.push(`/manage-case/${id}/products/add/notes`);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onOtherCharge = (key) => {
    try {
      const { params: { id }, setOtherCharge } = this.props;
      setOtherCharge({ key });
      this._onGoBack();
      browserHistory.push(`/manage-case/${id}/products/add/other-charge`);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickContinueBarCode = async (key) => {
    try {
      const { products } = this.props;
      if ((products[key].ProductNo === '' && products[key].ProductBarcode !== null) && products[key].isScanProduct === true) {
        products[key] = Object.assign(products[key],
          {
            ProductNo: '',
            ProductEnterType: 'MANUAL',
            ProductValid: false,
            ProductDescription: '',
            isScanProduct: true,
            ProductBarcode: null
          });
      } else {
        products[key] = Object.assign(products[key],
          {
            ProductNo: '',
            ProductEnterType: '',
            ProductValid: true,
            ProductDescription: '',
            isScanProduct: true,
            ProductBarcode: null
          });
      }
      await this.updateProducts();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onEnterProduct = async (event, key) => {
    try {
      const { target: { value } } = event;
      const productNo = value.split('-').join('').split(' ').join('')
        .toUpperCase();
      if (productNo !== '') {
        const manualProduct = { ProductNo: productNo, key };
        const productMasterRes = await getProduct('ProductNo', manualProduct.ProductNo);
        this.setState({ manualProduct });
        if (Object.keys(productMasterRes).length > 0) {
          manualProduct.ProductDescription = productMasterRes.ProductDescription;
          await this._onClickContinue('ProductValid');
        } else {
          this.manuallyProductWarnModal.show();
        }
      } else {
        await this._onClickContinueBarCode(key);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onEnterLot = async (event, key) => {
    try {
      const { target: { value } } = event;
      const lotNo = value.split('-').join('').split(' ').join('');
      if (lotNo !== '') {
        const manualLot = { LotNo: lotNo, key };
        this.setState({ manualLot }, async () => {
          await this._onClickLotContinue();
        });
      }
      const { setProducts } = this.props;
      const { products } = this.state;
      products[key] = Object.assign(products[key], { LotNo: lotNo });
      setProducts(products);
      this.setState({ products });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickLotContinue = async () => {
    try {
      const { products } = this.props;
      const { manualLot } = this.state;
      if (Object.keys(manualLot).length > 0) {
        const { key, LotNo } = manualLot;
        products[key] = Object.assign(products[key],
          {
            LotNo,
            LotEnterType: 'MANUAL',
            isScanLot: true
          });
      }
      await this.updateProducts();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickContinue = async (value) => {
    try {
      const { products } = this.props;
      const { manualProduct } = this.state;
      if (Object.keys(manualProduct).length > 0) {
        const { key, ProductNo, ProductDescription } = manualProduct;
        products[key] = Object.assign(products[key],
          {
            ProductNo,
            ProductEnterType: 'MANUAL',
            ProductValid: value === 'ProductValid',
            ProductDescription,
            isScanProduct: true,
          });
      }
      await this.updateProducts();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onTryAgain = async () => {
    try {
      const { manualProduct } = this.state;
      window.$(`#ProductNo${manualProduct.key}`).focus();
      setTimeout(() => {
        this._onScrollToBottom();
      }, 500);
      // await this.updateProducts();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onProductGoBack = async () => {
    try {
      const { products } = this.state;
      const {
        goBack, setProducts, params: { id }, tableName
      } = this.props;
      const caseRes = await getTableCaseByCaseId(id, tableName);
      let oldSets = [];
      oldSets = caseRes.case_products.map(
        ({
          ProductNo,
          ProductDescription,
          RepCaseNo,
          RepInventoryType,
          LotNo,
          UnitPrice,
          CaseProductsID
        }) => ({
          ProductNo,
          ProductDescription,
          RepCaseNo,
          RepInventoryType,
          LotNo,
          UnitPrice,
          CaseProductsID
        })
      );
      let newSets = [];
      newSets = products.map(
        ({
          ProductNo,
          ProductDescription,
          RepCaseNo,
          RepInventoryType,
          LotNo,
          UnitPrice,
          CaseProductsID
        }) => ({
          ProductNo,
          ProductDescription,
          RepCaseNo,
          RepInventoryType,
          LotNo,
          UnitPrice,
          CaseProductsID
        })
      );

      const productsClone = [...newSets];
      productsClone.pop();
      if (JSON.stringify(productsClone) !== JSON.stringify(oldSets)) {
        this.setBackModal.show();
      } else {
        onGoBack(goBack);
        setProducts([]);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  updateProducts = async () => {
    try {
      const {
        products, dispatch, setProducts
      } = this.props;
      const productData = [];
      setProducts(products);
      if (!products.some(({ ProductNo }) => ProductNo === '' || ProductNo === undefined) || products.length === 0) {
        products.push({
          CaseNo: null,
          RepCaseNo: null,
          ProductBarcode: null,
          LotBarcode: null,
          ScanDate: '',
          RepInventoryType: null,
          ScanOrder: null,
          ProductRep: null,
          DeviceID: null,
          Submitted: 0,
          Imported: '0',
          ProductEnterType: null,
          LotEnterType: null,
          ProductValid: true,
          BarcodeType: null,
          ScanError: null,
          AppGeneratedID: null,
          UnitPrice: null,
          ProductCaseNo: null,
          uploadedToAPI: false,
          ProductNo: '',
          ProductDescription: '',
          LotNo: null,
          InventoryType: null,
          isScanProduct: true,
          isScanLot: true,
          isOtherCharge: false,
          Wasted: '0',
        });
      }

      products.map((item) => {
        productData.push(Object.assign(item, {
          isScanProduct: item.isScanProduct,
          isScanLot: item.isScanLot,
        }));
      });

      await this.setState({ products: productData }, () => {
        productData.map((item, key) => {
          dispatch(change('scanProductForm', `ProductNo${key}`, item.ProductNo));
          dispatch(change('scanProductForm', `LotNo${key}`, item.LotNo));
          dispatch(change('scanProductForm', `ProductDescription${key}`, item.ProductDescription));
          dispatch(change('scanProductForm', `RepInventoryType${key}`, item.RepInventoryType));
        });
      });
      this.setState({ products });
      setProducts(products);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClearAllProduct = () => {
    try {
      this.clearAllProductsModal.show();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClearAll = async () => {
    try {
      const {
        setProducts, online, params: { id }, setLoader, notify, tableName
      } = this.props;
      const { products } = this.state;
      const caseDetail = await getTableCaseByCaseId(id, tableName);

      if (online) {
        setLoader(true);

        products.map((item, key) => {
          if (item.Wasted === '1') {
            let newNote = '';
            if (item.LotNo === null) {
              newNote += `${Number(key) + 1}.Wasted: ${item.ProductNo} /`;
            } else {
              newNote += `${Number(key) + 1}.Wasted: ${item.ProductNo} / ${item.LotNo}`;
            }

            caseDetail.ProductNotes = caseDetail.ProductNotes.replace(newNote, '').trim();
          }
        });

        // eslint-disable-next-line no-async-promise-executor
        const removePromiseAll = products.map(async (product) => new Promise(async (resolve) => {
          if (product.hasOwnProperty('CaseProductsID')) {
            await removeProduct(product.CaseProductsID);
          } else {
            product.RepInventoryType = '';
          }
          resolve(true);
        }));
        await Promise.all(removePromiseAll);
        setLoader(false);
        const compareValue = await this.compareUpdatedValue();
        if (compareValue) {
          caseDetail.ProductSubmitted = '0';
          caseDetail.Submitted = '0';
        }
        caseDetail.case_products = [];
        await updateTableCaseByPrimaryId(id, caseDetail, tableName);
        // await updateCaseByPrimaryId(id, caseDetail);
        // Remove from redux & state
        products.splice(0, products.length - 1);
        this.setState({ products });
        setProducts(products);
        await this.updateProducts();

        const caseRes = await getTableCaseByCaseId(id, tableName);
        this.setState({ caseRes });
      } else {
        notify({
          type: 'error',
          message: 'You must have as internet connection. Please check your connection and try again.',
          time: 3
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onBackCancel = () => {
    try {
      const { goBack, setProducts } = this.props;
      onGoBack(goBack);
      setProducts([]);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onProductSave = () => {
    try {
      const { products, team: { dgrRequired }, online } = this.props;
      const { dgrsCount, caseData } = this.state;

      if (caseData.DGR === '1') {
        this.ProductNotSaveModal.show();
      } else {
        let inventoryCount = 0;
        const productsClone = [...products];
        productsClone.pop();
        productsClone.map((item) => {
          if (item.RepInventoryType === null || item.RepInventoryType === '') {
            inventoryCount += 1;
          }
        });
        this.setState({ inventoryCount });
        if (inventoryCount > 0) {
          this.saveProductErrortModal.show();
          this.saveProductModalModal.hide();
        } else if (online && products.length > 1 && dgrsCount === 0 && dgrRequired > 0) {
          this.dgrRequiredModal.show();
          this.saveProductErrortModal.hide();
          this.saveProductModalModal.hide();
        } else {
          const lotCount = [];
          const productCount = [];
          if (products.length > 1) {
            if (products.length > 1) {
              products.map((value) => {
                if (value.Imported.toString() === '0' && typeof value.ProductNo !== 'undefined' && value.ProductNo !== '') {
                  productCount.push(value.Imported);
                  if (value.LotNo !== 'No Lot #' && value.LotNo !== '' && value.LotNo !== null) {
                    lotCount.push(value.LotNo);
                  }
                }
              });
            }
            this.setState({ lotCount: lotCount.length });
            this.setState({ productCount: productCount.length });
            this.setState({
              dgrAddedStatus: false
            }, () => {
              this.saveProductModalModal.show();
            });
          } else {
            this._onSubmit();
          }
        }
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickNoDrgRequired = () => {
    try {
      const { products } = this.props;
      const lotCount = [];
      const productCount = [];
      if (products.length > 1) {
        products.map((value) => {
          if (value.Imported.toString() === '0' && typeof value.ProductNo !== 'undefined' && value.ProductNo !== '') {
            productCount.push(value.Imported);
            if (value.LotNo !== 'No Lot #' && value.LotNo !== '' && value.LotNo !== null) {
              lotCount.push(value.LotNo);
            }
          }
        });
        this.setState({ lotCount: lotCount.length });
        this.setState({ productCount: productCount.length });
        this.saveProductModalModal.show();
      } else {
        this._onSubmit();
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  /* _onTakePhotoFile = async (formData) => {
    try {
      const {
        setLoader, notify, online, params: { id }, tableName
      } = this.props;
      const caseDetailsRes = await getTableCaseByCaseId(id, tableName);
      if (caseDetailsRes && caseDetailsRes.DGR === '1') {
        this.caseChangesNoLonger.show();
        return;
      }
      const body = formData;
      setLoader(true);
      if (online) {
        this.takePhotoModal.hide();
        uploadDgr({
          CaseScheduleID: caseDetailsRes.CaseScheduleID,
          OriginalFile: body
        }).then(async (responseJson) => {
          setLoader(false);
          const { status, message, data } = responseJson;
          if (status) {
            if (message.length > 0) {
              notify({ type: 'success', message });
            }
            // Update into local db
            caseDetailsRes.case_dgrs.push(data);
            await updateCase(caseDetailsRes);
            await updateTableWiseCaseByCaseId(caseDetailsRes.RepCaseNo, caseDetailsRes, tableName);
            await this._getDgrsCount();
          } else {
            notify({ type: 'error', message });
          }
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }; */

  _onClickDgrs = () => {
    try {
      const { products } = this.state;
      const {
        online, notify, setReadOnlyProductNotes
      } = this.props;

      let inventoryCount = 0;
      const productsClone = [...products];

      productsClone.pop();
      productsClone.map((item) => {
        if (item.RepInventoryType === null || item.RepInventoryType === '') {
          inventoryCount += 1;
        }
      });

      if (online) {
        this.setState({ inventoryCount });
        if (inventoryCount > 0) {
          this.saveProductErrortModal.show();
          this.saveProductModalModal.hide();
        } else {
          // document.getElementById('uploadDGREle').click();
          setReadOnlyProductNotes(false);

          this.setState({
            dgrAddedStatus: true
          }, () => {
            this._onSubmit();
          });
        }
      } else {
        notify({ type: 'error', message: 'DGRs cannot be viewed without an internet connection' });
      }
      // this.takePhotoModal.show();
      // this._onGoBack();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getDgrsCount = async () => {
    try {
      const { params: { id }, tableName } = this.props;
      const caseRes = await getTableCaseByCaseId(id, tableName);
      if (caseRes !== undefined) {
        const newDgrCount = caseRes.case_dgrs.filter((elm) => elm);
        if (newDgrCount) {
          this.setState({
            dgrsCount: newDgrCount.length
          });
        }
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onCancelUploadImage = () => {
    try {
      const { browserDetect } = this.props;

      if (browserDetect === 'Safari') {
        this._handleUploadClose();

        // document.addEventListener('visibilitychange', this._handleUploadClose);
        // window.addEventListener('focus', this._handleUploadClose, { once: true });

        // window.onfocus = this._handleUploadClose;
        // document.body.onfocus = this._handleUploadClose;

        // // Listen for blur (triggers when the camera opens)
        // window.addEventListener('blur', this._handleUploadClose);
        // // Listen for focus (triggers when the camera closes)
        // window.addEventListener('focus', this._handleUploadClose);

        // setInterval(this._handleUploadClose, 1000);
        // window.addEventListener('beforeunload', this._handleUploadClose);
      } else {
        window.addEventListener('focus', this._onRedirectToDgr);
      }

      // document.body.onfocus = this._onRedirectToDgr;
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _handleUploadClose = () => {
    setTimeout(() => {
      const uploadFile = this.uploadRef.current;
      if (!uploadFile || !uploadFile.files.length) {
        this._onRedirectToDgr();
      }

      // const uploadFiles = document.getElementById('uploadDGREle').files[0];
      // console.log(uploadFiles);
    }, 3000); // iOS Safari requires a delay
  };

  _onRedirectToDgr = () => {
    try {
      // const $this = this;
      // setTimeout(() => {
      //   const { dgrRedirectStatus } = this.state;
      //   const { params: { id }, goBack, setGoBack } = $this.props;
      //   const uploadFile = document.getElementById('uploadDGREle');

      //   if (uploadFile !== null && uploadFile.value.length) {
      //   } else {
      //     // this._onGoBack();
      //     if (!dgrRedirectStatus) {
      //       goBack.push(`/manage-case/${id}/products/add`);
      //       setGoBack(goBack);
      //       browserHistory.push(`/manage-case/${id}/products/dgr`);
      //     }
      //   }
      //   document.body.onfocus = null;
      //   this.setState({ dgrRedirectStatus: false });
      // }, 1000);

      setTimeout(() => {
        if (document.hidden) return; // Prevent execution if browser is in background
        const { dgrRedirectStatus } = this.state;
        const {
          params: { id }, goBack, setGoBack
        } = this.props;
        const uploadFile = document.getElementById('uploadDGREle');

        if (!uploadFile || !uploadFile.value.length) {
          if (!dgrRedirectStatus) {
            goBack.push(`/manage-case/${id}/products/add`);
            setGoBack(goBack);
            browserHistory.push(`/manage-case/${id}/products/dgr`);
          }
        }

        // window.removeEventListener('focus', this._onRedirectToDgr);
        // document.removeEventListener('visibilitychange', this._onRedirectToDgr);

        // if (browserDetect === 'Safari') {
        //   document.removeEventListener('visibilitychange', this._onRedirectToDgr);
        // } else {
        //   window.removeEventListener('focus', this._onRedirectToDgr);
        // }

        this.setState({ dgrRedirectStatus: false });
      }, 1000);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSelectImage = async (formData) => {
    try {
      if (formData.files.length > 0) {
        const uploadFile = document.getElementById('uploadDGREle');

        const {
          setLoader, notify, online, params: { id }, tableName, products
        } = this.props;
        const caseDetailsRes = await getTableCaseByCaseId(id, tableName);
        if (caseDetailsRes && caseDetailsRes.DGR === '1') {
          this.caseChangesNoLonger.show();
          return;
        }

        const body = formData.files[0];
        if (!(/\.(gif|jpg|jpeg|tiff|png|pdf|heic)$/i).test(body.name)) {
          notify({ type: 'error', message: 'Only images and PDF files are allowed for DGR uploads.' });
          return;
        }

        setLoader(true);
        if (online) {
          this.setState({ dgrRedirectStatus: true });
          // this.selectFileOrTakePhoto.hide();
          // this.takePhotoModal.hide();
          uploadDgr({
            CaseScheduleID: caseDetailsRes.CaseScheduleID,
            OriginalFile: body
          }).then(async (responseJson) => {
            setLoader(false);
            const {
              message, data, result
            } = responseJson;
            if (result === 'success') {
              if (message.length > 0) {
                uploadFile.value = null;
                // notify({ type: 'success', message });
              }
              // Update into local db
              caseDetailsRes.id = Number(id);
              caseDetailsRes.case_dgrs.push(data);
              caseDetailsRes.DGRUpload = '2';
              if (
                typeof caseDetailsRes.ProductNotes !== 'undefined'
                && (caseDetailsRes.ProductNotes === '' || caseDetailsRes.ProductNotes === null)
              ) {
                if (products.length === 1) {
                  caseDetailsRes.ProductNotes = 'No products used';
                }
              }
              // caseDetailsRes.ProductSubmitted = '0';
              await updateCase(caseDetailsRes);
              const updatedCaseRes = await listSingleCase(caseDetailsRes.CaseScheduleID);
              const updatedCase = updatedCaseRes.data[0];
              updatedCase.id = Number(id);
              await updateTableWiseCaseByCaseId(caseDetailsRes.id, updatedCase, tableName);
              await this._getDgrsCount();
              this.setState({ dgrAddedStatus: true });
              this._onSubmit();
            } else if (result === 'failure') {
              notify({ type: 'error', message });
            } else {
              notify({ type: 'error', message });
            }
          });
        }
      } else {
        this._onRedirectToDgr();
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _focusNextElement = (event) => {
    try {
      if (event.key === 'Enter') {
        event.preventDefault();
        const focusAbleElements = 'a:not([disabled]), button:not([disabled]), input[type=text]:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])';
        if (document.activeElement && document.activeElement.form) {
          const focusAble = Array.prototype.filter.call(
            document.activeElement.form.querySelectorAll(focusAbleElements),
            (element) => element.offsetWidth > 0
              || element.offsetHeight > 0
              || element === document.activeElement
          );
          const index = focusAble.indexOf(document.activeElement);
          if (index > -1) {
            const nextElement = focusAble[index + 1] || focusAble[0];
            nextElement.focus();
          }
        }
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onScrollToBottom = () => {
    window.scrollTo(0, document.body.scrollHeight);
  };

  _onClickVelysUsed = async () => {
    try {
      const { params: { id }, tableName } = this.props;
      const caseDetail = await getTableCaseByCaseId(id, tableName);
      if (Object.keys(caseDetail).length > 0) {
        if (caseDetail.CaseType === 'HIP') {
          this.vhnPpcModal.show();
          return;
        }
        if (caseDetail.CaseType === 'KNEE') {
          this.vrasPpcModal.show();
          return;
        }
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickNeedPrice = async () => {
    const { NeedPrice, caseData } = this.state;
    const { tableName, params: { id }, online } = this.props;
    try {
      const submitData = {
        ...caseData,
        NeedPrice: !NeedPrice
      };
      const caseDetail = await getTableCaseByCaseId(id, tableName);
      caseDetail.NeedPrice = submitData.NeedPrice ? '1' : '0';
      caseDetail.Sync = online ? 0 : 1;
      updateTableCaseByPrimaryId(id, caseDetail, tableName);
      if (online) {
        await updateCase(submitData);
      }
      this.setState({
        NeedPrice: !NeedPrice
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickVhnPpcYesScanProduct = async () => {
    try {
      const {
        params: { id }, tableName, setLoader, online,
        user: { name, territories, office }
      } = this.props;
      const caseDetail = await getTableCaseByCaseId(id, tableName);
      let vhnPpcValue = {};
      if (caseDetail.CustomerName !== null) {
        const vhnPpc = await getVhnPpcValue(caseDetail.CustomerName);
        if (typeof vhnPpc !== 'undefined') {
          vhnPpcValue = vhnPpc;
        }
      }
      const territoriesData = territories.find((item) => item.offices.some(
        (value) => value.id === office
      ));
      const officeData = territoriesData.offices.find((o) => o.id === office);
      const complainAppData = {
        CaseScheduleID: caseDetail.CaseScheduleID,
        OfficeName: officeData.name,
        RepCaseNo: caseDetail.RepCaseNo,
        UserName: name,
        ComplianceType: vhnPpcValue.VHN_PPC === '1' ? 'VHN-PPC' : 'VHN-Other',
        UserResponse: 'YES',
        // ResponseDate: moment(new Date()).tz(SERVER_TIMEZONE).format('YYYY-MM-DD HH:mm:ss.SSS'),
        ResponseDate: moment(new Date()).format('YYYY-MM-DD HH:mm:ss.SSS'),
        Sync: online ? 0 : 1
      };
      if (online) {
        setLoader(true);
        await addComplianceAppData({
          CaseScheduleID: caseDetail.CaseScheduleID,
          ComplianceType: complainAppData.ComplianceType,
          UserResponse: complainAppData.UserResponse
        })
          .then(async (response) => {
            if (response.message === 'VHN Compliance added successsfully') {
              await insertComplianceApp(complainAppData);
              const newArrayOfObj = caseDetail.case_sets.map(({
                CasePlanId: CasePlanID,
                ...rest
              }) => ({
                CasePlanID,
                ...rest
              }));
              caseDetail.selectSets = newArrayOfObj;
              caseDetail.Submitted = '0';
              caseDetail.Synced = '0';
              caseDetail.VelysUsed = 'YES';
              await updateCase(caseDetail);
              // Update into local db
              updateTableCaseByPrimaryId(caseDetail.id, caseDetail, tableName);
              this.setState({ caseRes: caseDetail });
            }
          });
        setLoader(false);
      } else {
        setLoader(true);
        await insertComplianceApp(complainAppData);
        caseDetail.Sync = 1;
        caseDetail.VelysUsed = 'YES';
        caseDetail.Submitted = '0';
        // Update into local db
        updateTableCaseByPrimaryId(caseDetail.id, caseDetail, tableName);
        this.setState({ caseRes: caseDetail });
        setLoader(false);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickVhnPpcNoScanProduct = async () => {
    try {
      const {
        params: { id }, tableName, setLoader, online,
        user: { name, territories, office }
      } = this.props;
      const caseDetail = await getTableCaseByCaseId(id, tableName);
      let vhnPpcValue = {};
      if (caseDetail.CustomerName !== null) {
        const vhnPpc = await getVhnPpcValue(caseDetail.CustomerName);
        if (typeof vhnPpc !== 'undefined') {
          vhnPpcValue = vhnPpc;
        }
      }
      const territoriesData = territories.find((item) => item.offices.some(
        (value) => value.id === office
      ));
      const officeData = territoriesData.offices.find((o) => o.id === office);
      const complainAppData = {
        CaseScheduleID: caseDetail.CaseScheduleID,
        OfficeName: officeData.name,
        RepCaseNo: caseDetail.RepCaseNo,
        UserName: name,
        ComplianceType: vhnPpcValue.VHN_PPC === '1' ? 'VHN-PPC' : 'VHN-Other',
        UserResponse: 'NO',
        // ResponseDate: moment(new Date()).tz(SERVER_TIMEZONE).format('YYYY-MM-DD HH:mm:ss.SSS'),
        ResponseDate: moment(new Date()).format('YYYY-MM-DD HH:mm:ss.SSS'),
        Sync: online ? 0 : 1
      };

      if (online) {
        setLoader(true);
        await addComplianceAppData({
          CaseScheduleID: caseDetail.CaseScheduleID,
          ComplianceType: complainAppData.ComplianceType,
          UserResponse: complainAppData.UserResponse
        })
          .then(async (response) => {
            if (response.message === 'VHN Compliance added successsfully') {
              await insertComplianceApp(complainAppData);
              const newArrayOfObj = caseDetail.case_sets.map(({
                CasePlanId: CasePlanID,
                ...rest
              }) => ({
                CasePlanID,
                ...rest
              }));
              caseDetail.selectSets = newArrayOfObj;
              caseDetail.Submitted = '0';
              caseDetail.Synced = '0';
              caseDetail.VelysUsed = 'NO';
              await updateCase(caseDetail);
              // Update into local db
              updateTableCaseByPrimaryId(caseDetail.id, caseDetail, tableName);
              this.setState({ caseRes: caseDetail });
            }
          });
        setLoader(false);
      } else {
        setLoader(true);
        await insertComplianceApp(complainAppData);
        caseDetail.Sync = 1;
        caseDetail.VelysUsed = 'NO';
        caseDetail.Submitted = '0';
        // Update into local db
        updateTableCaseByPrimaryId(caseDetail.id, caseDetail, tableName);
        this.setState({ caseRes: caseDetail });
        setLoader(false);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickVrasPpcYesScanProduct = async () => {
    try {
      const {
        params: { id }, tableName, setLoader, online,
        user: { name, territories, office }
      } = this.props;
      const caseDetail = await getTableCaseByCaseId(id, tableName);
      let vhnPpcValue = {};
      if (caseDetail.CustomerName !== null) {
        const vhnPpc = await getVhnPpcValue(caseDetail.CustomerName);
        if (typeof vhnPpc !== 'undefined') {
          vhnPpcValue = vhnPpc;
        }
      }
      const territoriesData = territories.find((item) => item.offices.some(
        (value) => value.id === office
      ));
      const officeData = territoriesData.offices.find((o) => o.id === office);
      const complainAppData = {
        CaseScheduleID: caseDetail.CaseScheduleID,
        OfficeName: officeData.name,
        RepCaseNo: caseDetail.RepCaseNo,
        UserName: name,
        ComplianceType: vhnPpcValue.VRAS_PPC === '1' ? 'VRAS-PPC' : 'VRAS-Other',
        UserResponse: 'YES',
        // ResponseDate: moment(new Date()).tz(SERVER_TIMEZONE).format('YYYY-MM-DD HH:mm:ss.SSS'),
        ResponseDate: moment(new Date()).format('YYYY-MM-DD HH:mm:ss.SSS'),
        Sync: online ? 0 : 1
      };
      if (online) {
        setLoader(true);
        await addComplianceAppData({
          CaseScheduleID: caseDetail.CaseScheduleID,
          ComplianceType: complainAppData.ComplianceType,
          UserResponse: complainAppData.UserResponse
        })
          .then(async (response) => {
            if (response.message === 'VHN Compliance added successsfully') {
              await insertComplianceApp(complainAppData);
              const newArrayOfObj = caseDetail.case_sets.map(({
                CasePlanId: CasePlanID,
                ...rest
              }) => ({
                CasePlanID,
                ...rest
              }));
              caseDetail.selectSets = newArrayOfObj;
              caseDetail.Submitted = '0';
              caseDetail.Synced = '0';
              caseDetail.VelysUsed = 'YES';
              await updateCase(caseDetail);
              // Update into local db
              updateTableCaseByPrimaryId(caseDetail.id, caseDetail, tableName);
              this.setState({ caseRes: caseDetail });
            }
          });
        setLoader(false);
      } else {
        setLoader(true);
        await insertComplianceApp(complainAppData);
        caseDetail.Sync = 1;
        caseDetail.VelysUsed = 'YES';
        caseDetail.Submitted = '0';
        // Update into local db
        updateTableCaseByPrimaryId(caseDetail.id, caseDetail, tableName);
        this.setState({ caseRes: caseDetail });
        setLoader(false);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickVrasPpcNoScanProduct = async () => {
    try {
      const {
        params: { id }, tableName, setLoader, online,
        user: { name, territories, office }
      } = this.props;
      const caseDetail = await getTableCaseByCaseId(id, tableName);
      let vhnPpcValue = {};
      if (caseDetail.CustomerName !== null) {
        const vhnPpc = await getVhnPpcValue(caseDetail.CustomerName);
        if (typeof vhnPpc !== 'undefined') {
          vhnPpcValue = vhnPpc;
        }
      }
      const territoriesData = territories.find((item) => item.offices.some(
        (value) => value.id === office
      ));
      const officeData = territoriesData.offices.find((o) => o.id === office);
      const complainAppData = {
        CaseScheduleID: caseDetail.CaseScheduleID,
        OfficeName: officeData.name,
        RepCaseNo: caseDetail.RepCaseNo,
        UserName: name,
        ComplianceType: vhnPpcValue.VRAS_PPC === '1' ? 'VRAS-PPC' : 'VRAS-Other',
        UserResponse: 'NO',
        // ResponseDate: moment(new Date()).tz(SERVER_TIMEZONE).format('YYYY-MM-DD HH:mm:ss.SSS'),
        ResponseDate: moment(new Date()).format('YYYY-MM-DD HH:mm:ss.SSS'),
        Sync: online ? 0 : 1
      };

      if (online) {
        setLoader(true);
        await addComplianceAppData({
          CaseScheduleID: caseDetail.CaseScheduleID,
          ComplianceType: complainAppData.ComplianceType,
          UserResponse: complainAppData.UserResponse
        })
          .then(async (response) => {
            if (response.message === 'VHN Compliance added successsfully') {
              await insertComplianceApp(complainAppData);
              const newArrayOfObj = caseDetail.case_sets.map(({
                CasePlanId: CasePlanID,
                ...rest
              }) => ({
                CasePlanID,
                ...rest
              }));
              caseDetail.selectSets = newArrayOfObj;
              caseDetail.Submitted = '0';
              caseDetail.Synced = '0';
              caseDetail.VelysUsed = 'NO';
              await updateCase(caseDetail);
              // Update into local db
              updateTableCaseByPrimaryId(caseDetail.id, caseDetail, tableName);
              this.setState({ caseRes: caseDetail });
            }
          });
        setLoader(false);
      } else {
        setLoader(true);
        await insertComplianceApp(complainAppData);
        caseDetail.Sync = 1;
        caseDetail.VelysUsed = 'NO';
        caseDetail.Submitted = '0';
        // Update into local db
        updateTableCaseByPrimaryId(caseDetail.id, caseDetail, tableName);
        this.setState({ caseRes: caseDetail });
        setLoader(false);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getById = async () => {
    try {
      const {
        dispatch, params: { id }, team: { salesAccess }, user: { name }, tableName, online
      } = this.props;

      let caseRes = await getTableCaseByCaseId(id, tableName);
      if (typeof caseRes.CustomerNo !== 'undefined' && caseRes.CustomerNo !== null) {
        const hosptalRes = await getHospitalByCustomerNo(caseRes.CustomerNo);
        this.setState({ hospitalNeedPrice: hosptalRes?.NeedPrice === '1' });
      }
      if (online) {
        if (caseRes !== null) {
          let _ignore;
          // eslint-disable-next-line no-unused-vars
          [caseRes, _ignore] = (await listSingleCase(caseRes.CaseScheduleID)).data;
        }
      }
      // if (caseRes && caseRes.ACMCaseID !== null) {
      //   this.acmCaseEditNotifyModal.show();
      // }
      // Get case time
      const currentDate = new Date();
      const timeValues = caseRes.CaseTime.split(':');
      const CaseDateTime = currentDate.setHours(timeValues[0], timeValues[1]);
      const newCoverRep = (salesAccess && caseRes.CoverRep === null) ? name : caseRes.CoverRep;
      if (Object.keys(caseRes).length > 0) {
        this.setState({
          selectedCaseId: (caseRes.ACMCaseID === null) ? caseRes.RepCaseNo : `${`${caseRes.RepCaseNo}(ACM)`}`,
          selectedType: caseRes.CaseType,
          selectedSurgeon: caseRes.SurgeonName,
          selectedHospital: caseRes.CustomerName,
          selectedProcedure: caseRes.ProcedureType,
          selectedSide: caseRes.Side,
          selectedCaseTime: new Date(CaseDateTime),
          selectedGender: caseRes.Gender,
          selectedCoverRep: (salesAccess && caseRes.CoverRep === null) ? name : caseRes.CoverRep,
          selectedCaseDate: new Date(caseRes.CaseDate.replace(/-/g, '/')),
          customerNo: caseRes.CustomerNo,
          RepNotes: caseRes.RepNotes,
          Comments: caseRes.Comments,
          NeedPrice: caseRes.NeedPrice === '1',
          PriceSheet: caseRes.PriceSheet === '1',
        }, () => {
          this.setState({ fixCaseData: { ...caseRes, ...this.state } });
        });
        Object.keys(caseRes).map((key) => {
          if (key === 'RepCaseNo' && caseRes.ACMCaseID !== null) {
            const RepCaseNo = `${`${caseRes.RepCaseNo} (ACM)`}`;
            caseRes.RepCaseNo = RepCaseNo;
          }
          dispatch(change('EditManageCaseForm', key, caseRes[key]));
        });
        this.setState({
          caseData: caseRes,
          manageCaseData: { ...caseRes },
          newCoverRep,
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onFFFCharge = () => {
    try {
      this.FFFModal.show();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onFFFSaveNo = async () => {
    try {
      const {
        params: { id }, tableName
      } = this.props;
      const caseDetail = await getTableCaseByCaseId(id, tableName);
      caseDetail.FFFValue = null;
      caseDetail.FFFRep = null;
      caseDetail.FFFDate = null;
      await updateCase(caseDetail);
      await updateTableCaseByPrimaryId(id, caseDetail, tableName);
      this.setState({ isFFFActivate: '' });
      this.FFFModal.hide();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onFFFSaveYes = async () => {
    try {
      const {
        params: { id }, tableName
      } = this.props;
      const caseDetail = await getTableCaseByCaseId(id, tableName);
      caseDetail.FFFValue = 'CONFIRMED';
      caseDetail.FFFRep = caseDetail.CreateRep;
      // caseDetail.FFFDate = moment(new Date()).tz(SERVER_TIMEZONE).format('YYYY-MM-DD');
      caseDetail.FFFDate = moment(new Date()).format('YYYY-MM-DD');
      await updateCase(caseDetail);
      await updateTableCaseByPrimaryId(id, caseDetail, tableName);
      this.setState({ isFFFActivate: 'CONFIRMED' });
      this.FFFModal.hide();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClickProductNotSave = async () => {
    try {
      const { goBack, params: { id } } = this.props;
      onGoBack(goBack);
      this.ProductNotSaveModal.hide();
      browserHistory.push(`/manage-case/${id}`);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onWastedProductSave = async (event, index) => {
    try {
      let WastedFlag;
      if (event.target.checked) {
        WastedFlag = '1';
      } else {
        WastedFlag = '0';
      }

      const { setProducts } = this.props;
      const { products } = this.state;
      products[index] = Object.assign(products[index], { Wasted: WastedFlag });
      setProducts(products);
      this.setState({ products });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onWastedProductNotes = (notess, productData) => {
    try {
      const productsClone = productData;
      let notes = notess.trim();
      notes = notes.replace('\n\n', '');

      productsClone.map((item, key) => {
        let newNote = '';
        if (item.LotNo === null) {
          newNote += `${Number(key) + 1}.Wasted: ${item.ProductNo} /`;
        } else {
          newNote += `${Number(key) + 1}.Wasted: ${item.ProductNo} / ${item.LotNo}`;
        }

        notes = notes.replace(newNote, '').trim();
      });

      notes = notes.replace('\n\n', '');
      notes.replace('\n\n', '').trim();
      notes.trim();

      productsClone.map((item, key) => {
        if (item.Wasted === '1') {
          if (!item.hasOwnProperty('CaseProductsID')) {
            let newNote = '';
            if (item.LotNo === null) {
              newNote += `${Number(key) + 1}.Wasted: ${item.ProductNo} /`;
            } else {
              newNote += `${Number(key) + 1}.Wasted: ${item.ProductNo} / ${item.LotNo}`;
            }

            notes.trim();
            notes += '\n';
            notes += newNote;
          } else {
            let newNote = '';
            if (item.LotNo === null) {
              newNote += `${Number(key) + 1}.Wasted: ${item.ProductNo} /`;
            } else {
              newNote += `${Number(key) + 1}.Wasted: ${item.ProductNo} / ${item.LotNo}`;
            }

            notes.trim();
            notes += '\n';
            notes += newNote;
          }
        }
      });

      return notes.trim();
    } catch (error) {
      return notess;
    }
  };

  _updateWastedProductNotes = async () => {
    try {
      const {
        params: { id }, online, tableName,
        user: {
          name,
        },
      } = this.props;

      if (online) {
        const caseDetail = await getTableCaseByCaseId(id, tableName);

        const {
          CaseScheduleID, CaseDate, CaseTime, CustomerNo, CustomerName, SurgeonName,
          PatientID, ProcedureType, CaseType, Side, Comments,
          RepNotes, ProductNotes,
          ProductSubmitted, RepPONumber, Submitted, CoverRep, DGRUpload,
          MRN, Gender, Age, ACMPlannedParts, ACMSelectedParts, Height, Weight, selectedSets,
          case_dgrs, ...partialObject
        } = caseDetail;
        const subset = {
          CaseScheduleID,
          CaseDate,
          CaseTime,
          CustomerNo,
          CustomerName,
          SurgeonName,
          PatientID,
          ProcedureType,
          CaseType,
          Side,
          Comments,
          RepNotes,
          ProductNotes,
          ProductSubmitted,
          RepPONumber,
          Submitted,
          CoverRep,
          ChangeRep: name,
          DGRUpload,
          MRN,
          Gender,
          Age,
          ACMPlannedParts,
          ACMSelectedParts,
          Height,
          Weight,
          selectedSets,
          case_dgrs,
        };
        const newArrayOfObj = partialObject.case_sets.map(({
          CasePlanId: CasePlanID,
          ...rest
        }) => ({
          CasePlanID,
          ...rest
        }));
        subset.selectedSets = newArrayOfObj;
        if (caseDetail.case_products.length > 0) {
          subset.ProductNotes = (subset.ProductNotes === '' || subset.ProductNotes === null || subset.ProductNotes === 'No products used') ? '' : subset.ProductNotes;
        }

        // eslint-disable-next-line no-unused-vars
        const caseData = (await listSingleCase(CaseScheduleID)).data;

        subset.ProductNotes = await this._onWastedProductNotes(
          subset.ProductNotes, caseData[0].case_products
        );

        subset.case_products = caseData[0].case_products;
        caseDetail.case_products = caseData[0].case_products;
        caseDetail.ProductNotes = subset.ProductNotes;

        await updateCase(subset);
        await updateTableCaseByPrimaryId(id, caseDetail, tableName);

        const caseRes = await getTableCaseByCaseId(id, tableName);
        this.setState({ caseRes });
      }

      return true;
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onListProductShow = (key) => {
    this.setState({ showSearchProducts: true });
    this.setState({ showSearchProductKey: key });
  }

  _onProductBack = () => {
    const { showSearchProducts } = this.state;
    if (showSearchProducts) {
      this.setState({ showSearchProducts: false });
    }
  };

  _onSelectProductNumbers = async (props) => {
    try {
      const { number, productKey } = props;

      const productData = await getProductDescriptionById(number);

      const { products } = this.props;
      products[productKey] = Object.assign(products[productKey],
        {
          ProductNo: number,
          ProductEnterType: 'MANUAL',
          ProductValid: true,
          ProductDescription: (typeof productData !== 'undefined' && productData !== '' ? productData : ''),
          isScanProduct: true,
        });

      await this.updateProducts();

      this._onProductBack();
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onDeleteProductSubmit = async () => {
    try {
      const { products, deleteProductKey } = this.state;
      const {
        setProducts, online, params: { id }, setLoader, tableName, notify, dgrRequired
      } = this.props;

      if (deleteProductKey > -1) {
        const index = deleteProductKey;
        const caseDetail = await getTableCaseByCaseId(id, tableName);
        const compareValue = await this.compareUpdatedValue();

        const {
          CaseScheduleID, CaseDate, CaseTime, CustomerNo, CustomerName, SurgeonName,
          PatientID, ProcedureType, CaseType, Side, Comments,
          RepNotes, ProductNotes,
          ProductSubmitted, RepPONumber, Submitted, CoverRep, DGRUpload,
          MRN, Gender, Age, ACMPlannedParts, ACMSelectedParts, Height, Weight, selectedSets,
          case_dgrs, ...partialObject
        } = caseDetail;
        const subset = {
          CaseScheduleID,
          CaseDate,
          CaseTime,
          CustomerNo,
          CustomerName,
          SurgeonName,
          PatientID,
          ProcedureType,
          CaseType,
          Side,
          Comments,
          RepNotes,
          ProductNotes,
          ProductSubmitted,
          RepPONumber,
          Submitted,
          CoverRep,
          ChangeRep: name,
          DGRUpload,
          MRN,
          Gender,
          Age,
          ACMPlannedParts,
          ACMSelectedParts,
          Height,
          Weight,
          selectedSets,
          case_dgrs
        };
        const newArrayOfObj = partialObject.case_sets.map(({
          CasePlanId: CasePlanID,
          ...rest
        }) => ({
          CasePlanID,
          ...rest
        }));
        subset.selectedSets = newArrayOfObj;
        subset.ProductNotes = (subset.ProductNotes === '' || subset.ProductNotes === null || subset.ProductNotes === 'No products used') ? '' : subset.ProductNotes;

        const data = products[index];
        const productsData = products;

        if (data.Wasted === '1') {
          let newNote = '';
          if (data.LotNo === null) {
            newNote += `${Number(index) + 1}.Wasted: ${data.ProductNo} /`;
          } else {
            newNote += `${Number(index) + 1}.Wasted: ${data.ProductNo} / ${data.LotNo}`;
          }

          if (caseDetail.ProductNotes !== null) {
            caseDetail.ProductNotes = caseDetail.ProductNotes.replace(newNote, '');
            caseDetail.ProductNotes = caseDetail.ProductNotes.replace('\n\n', '');
          }
        }

        const productCount = productsData.length;
        productsData.map((item, key) => {
          if (item.Wasted === '1' && key > index) {
            let newNote = '';
            let newNoteR = '';
            if (item.LotNo === null) {
              newNote += `${Number(key) + 1}.Wasted: ${item.ProductNo} /`;
              newNoteR += `${Number(productCount > 1 ? key : (key + 1))}.Wasted: ${item.ProductNo} /`;
            } else {
              newNote += `${Number(key) + 1}.Wasted: ${item.ProductNo} / ${item.LotNo}`;
              newNoteR += `${Number(productCount > 1 ? key : (key + 1))}.Wasted: ${item.ProductNo} / ${item.LotNo}`;
            }

            if (caseDetail.ProductNotes !== null) {
              caseDetail.ProductNotes = caseDetail.ProductNotes.replace(newNote, newNoteR);
              caseDetail.ProductNotes = caseDetail.ProductNotes.replace('\n\n', '');
            }
          }
        });

        if (online) {
          if (data.hasOwnProperty('CaseProductsID')) {
            setLoader(true);
            await removeProduct(data.CaseProductsID).then(async (response) => {
              setLoader(false);
              const { status, result, message } = response;
              if (status && result !== 'failure') {
                // products.splice(products.findIndex((a) => a.ProductNo === data.ProductNo), 1);
                products.splice(products.findIndex(
                  (a) => a.CaseProductsID === data.CaseProductsID
                ), 1);
              } else {
                notify({ type: 'error', message });
              }
            });
          } else {
            products.splice(products.findIndex((a) => a.ProductNo === data.ProductNo), 1);
          }
        } else {
          products.splice(products.findIndex((a) => a.ProductNo === data.ProductNo), 1);
        }

        // products.map((item, key) => {
        //   if (item.Wasted === '1') {
        //     if (!item.hasOwnProperty('CaseProductsID')) {
        //       let newNote = '';
        //       if (item.LotNo === null) {
        //         newNote += `${Number(key) + 1}.Wasted: ${item.ProductNo} /`;
        //       } else {
        //         newNote += `${Number(key) + 1}.Wasted: ${item.ProductNo} / ${item.LotNo}`;
        //       }

        //       caseDetail.ProductNotes.trim();
        //       caseDetail.ProductNotes += '\n';
        //       caseDetail.ProductNotes += newNote;
        //     } else {
        //       let newNote = '';
        //       if (item.LotNo === null) {
        //         newNote += `${Number(key) + 1}.Wasted: ${item.ProductNo} /`;
        //       } else {
        //         newNote += `${Number(key) + 1}.Wasted: ${item.ProductNo} / ${item.LotNo}`;
        //       }

        //       caseDetail.ProductNotes.trim();
        //       caseDetail.ProductNotes += '\n';
        //       caseDetail.ProductNotes += newNote;
        //     }
        //   }
        // });

        const productNote = caseDetail.ProductNotes;
        if (productNote !== null) {
          caseDetail.ProductNotes = productNote.trim();
          subset.ProductNotes = productNote.trim();
        } else {
          subset.ProductNotes = caseDetail.ProductNotes;
        }

        const productClone = [...products];
        productClone.pop();

        if (compareValue) {
          caseDetail.ProductSubmitted = '0';
        }

        caseDetail.case_products = productClone;
        subset.case_products = productClone;
        await updateTableCaseByPrimaryId(id, caseDetail, tableName);

        this.setState({ products });
        setProducts(products);

        if (online) {
          if (compareValue) {
            subset.ProductSubmitted = '0';
          }

          if (subset.case_dgrs.length === 0 && dgrRequired > 0) {
            subset.DGRUpload = '1';
          }

          await updateCase(subset);
        }

        await this.updateProducts();

        const caseRes = await getTableCaseByCaseId(id, tableName);
        this.setState({ caseRes });
      }

      this.deleteProductModalModal.hide();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  async UNSAFE_componentWillMount() {
    try {
      const {
        params: { id }, setProducts,
        products, otherCharge, setOtherCharge, tableName, setLoader,
        user: { territories, selectedTeam, territoryId }
      } = this.props;
      setLoader(true);
      if (id) {
        await this._getById();
      }
      setTimeout(() => {
        this._onScrollToBottom();
      }, 1000);
      const productInventoryType = await getInventoryType();
      const sortOnName = sortData(productInventoryType, 'OptionName');
      const sortRes = sortData(sortOnName, 'OptionAbb');
      const caseRes = await getTableCaseByCaseId(id, tableName);
      await this._getDgrsCount();
      // Get product from case
      if (products.length > 0) {
        setProducts(products);
      } else if (id !== null) {
        const productData = [];
        const caseDetail = await getTableCaseByCaseId(id, tableName);
        if (caseDetail && caseDetail.case_products.length > 0) {
          caseDetail.case_products.map((item) => {
            productData.push(Object.assign(item, {
              isScanProduct: true,
              isScanLot: true,
              isOtherCharge: true,
            }));
          });
          this.setState({ products: productData });
          setProducts(productData);
        }
      }

      if (Object.keys(otherCharge).length > 0) {
        await this.updateProducts();
        products[products.length - 1] = Object.assign(products[products.length - 1],
          {
            ProductNo: otherCharge.OptionNo !== undefined ? otherCharge.OptionNo : '',
            ProductDescription: otherCharge.OptionName !== undefined ? otherCharge.OptionName : '',
            LotNo: 'No Lot #',
            RepInventoryType: otherCharge.amount !== undefined ? `Other - $${otherCharge.amount}` : '',
            UnitPrice: otherCharge.amount !== undefined ? otherCharge.amount : '',
            isOtherCharge: true,
          });
        this.setState({ products });
        setProducts(products);

        setOtherCharge({});
      }

      this.setState({ productInventoryType: sortRes, caseRes });
      await this.updateProducts();
      $('select').select2({
        minimumResultsForSearch: -1,
        placeholder: 'Select Inventory Type'
      });

      territories.map((item) => {
        if (item.isFFF && item.id === territoryId) {
          if (item.hasOwnProperty('offices')) {
            item.offices.map((office) => {
              if (office.hasOwnProperty('teams')) {
                office.teams.map((team) => {
                  if (team.isFFF && team.id === selectedTeam.id) {
                    this.setState({ territoryData: team.isFFF });
                  }
                });
              }
            });
          }
        }
      });

      if (this.state.territoryData) {
        this.setState({ isFFFVisable: true });
        this.setState({ isFFFActivate: caseRes.FFFValue });
      }
      setLoader(false);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const {
      handleSubmit, user, browserDetect
    } = this.props;
    const {
      productInventoryType, products, inventoryCount, caseRes, lotCount,
      productCount, dgrsCount, NeedPrice, PriceSheet, hospitalNeedPrice,
      showSearchProducts, showSearchProductKey,
    } = this.state;

    return (
      <div className="site-wrapper">
        {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
        <form onSubmit={handleSubmit(this._onProductSave)} onKeyPress={this._focusNextElement} form="scanProductForm">

          <section className="sticky-top">
            {
              showSearchProducts
                ? (
                  <Header
                    title="Product"
                    goBack={this._onProductBack}
                  />
                ) : (
                  <Header
                    actionButton={products.length > 0 && { title: 'Save' }}
                    title="Scan Products"
                    goBack={this._onProductGoBack}
                  />
                )
            }
          </section>

          {
            showSearchProducts
              ? (
                <SearchByProduct
                  selectedProductKey={showSearchProductKey}
                  onProductSelect={this._onSelectProductNumbers}
                />
              ) : (
                <>
                  <section className="scan-section">
                    <div className="container">

                      <div className="top-block">
                        <div className="row">
                          <div className="col">
                            <p>Products: {
                              // products.length > 0 ? products.length - 1 : 0
                              products.reduce((sum, item) => {
                                if (item.Imported.toString() === '0' && item.ProductNo !== '') {
                                  return sum + Number(1);
                                }
                                return sum;
                              }, 0)
                            }
                            </p>
                          </div>
                          <div className="col" style={{ display: 'inline-flex', justifyContent: 'center', alignItems: 'center' }}>
                            {
                              caseRes.VelysUsed !== null
                              && (
                                <div style={{ display: 'flex' }}>
                                  <Link onClick={() => this._onClickVelysUsed()}>
                                    <img src={VelysLogoOrange} width="25" alt="icon" />
                                  </Link>
                                  <p className="ms-1 mb-0" style={{ fontSize: 14, whiteSpace: 'nowrap', fontWeight: 'normal' }}>{caseRes.VelysUsed === 'YES' ? 'Used' : 'Not Used'}</p>
                                </div>
                              )
                            }
                          </div>
                          <div className="col" style={{ justifyContent: 'center' }}>
                            {
                              !PriceSheet && hospitalNeedPrice && (
                                <div className="form-check" style={{ display: 'flex' }}>
                                  <input
                                    id="needPrice"
                                    name="needPrice"
                                    type="checkbox"
                                    checked={NeedPrice}
                                    className="form-check-input"
                                    style={{ height: 18, width: 18, marginRight: 6 }}
                                    onChange={() => this._onClickNeedPrice()}
                                  />
                                  <label className="form-check-label" htmlFor="needPrice" style={{ whiteSpace: 'nowrap' }}>Need Price</label>
                                </div>
                              )
                            }
                          </div>
                        </div>
                      </div>

                      {
                        products.map((item, key) => (
                          (item.Imported.toString() === '0')
                            ? (
                              <div className="scan-list" key={key}>

                                <div className={`d-flex justify-content-between align-items-start form-group ${(products.length - 1 !== key) ? '' : 'fill'}`}>
                                  <div className="product-icon">
                                    <Field
                                      type="text"
                                      id={`ProductNo${key}`}
                                      name={`ProductNo${key}`}
                                      className={`form-control ${item.ProductNo !== '' ? 'case-product-filled' : 'product-scan-border'}`}
                                      placeholder={`${((item.ProductNo === '' && (item.ProductBarcode !== null)) && item.isScanProduct === true)
                                        ? 'Enter Product' : item.isScanProduct && user.scanner
                                          ? 'Scan Product' : 'Enter Product'} #`}
                                      component={renderField}
                                      validate={((products.length - 1) > key)
                                        ? [required]
                                        : []}
                                      onClick={
                                        ((item.ProductNo === '' && (item.ProductBarcode !== null)) && item.isScanProduct === true)
                                          ? () => { } : item.isScanProduct && user.scanner
                                            ? () => this._onProductClick(key) : () => { }
                                      }
                                      onBlur={(e) => { this._onEnterProduct(e, key); }}
                                      disabled={(item.ProductNo !== '') && item.isScanProduct}
                                      autoFocus={item.ProductNo === '' && item.ProductBarcode !== null}
                                    />

                                    {
                                      item.ProductDescription && (
                                        <p className="mb-0">{item.ProductDescription}</p>
                                      )
                                    }

                                    <Field
                                      type="hidden"
                                      name={`ProductDescription${key}`}
                                      placeholder="Product Description"
                                      component={renderField}
                                      disabled
                                    />

                                  </div>

                                  {
                                    (item.ProductNo !== '') && (
                                      <div
                                        className="form-check d-flex justify-content-start align-items-start position-relative"
                                        style={{ top: '5px' }}
                                      >
                                        <input
                                          id={`Wasted${key}`}
                                          name={`Wasted${key}`}
                                          type="checkbox"
                                          checked={item.Wasted === '1' ? 'checked' : ''}
                                          className="form-check-input"
                                          style={{ height: 18, width: 18, marginRight: 6 }}
                                          onChange={
                                            (event) => this._onWastedProductSave(event, key)
                                          }
                                        />
                                        <label className="form-check-label" htmlFor={`Wasted${key}`} style={{ whiteSpace: 'nowrap', margin: '2px' }}>Wasted</label>
                                      </div>
                                    )
                                  }

                                  {
                                    (item.ProductNo === '') && (
                                      <div
                                        className="form-check d-flex justify-content-center align-items-start position-relative"
                                        style={{ top: '8px' }}
                                      >
                                        <Link className="cursor-pointer" onClick={() => this._onListProductShow(key)}>
                                          <img src={ProductListIcon} alt="" style={{ width: '20px' }} />
                                        </Link>
                                      </div>
                                    )
                                  }

                                  <i
                                    className={`icon-rights ${((item.ProductNo === '' && item.ProductBarcode === null) && item.isScanProduct === true)
                                      ? 'fas fa-keyboard'
                                      : (item.ProductBarcode !== null)
                                        ? 'fas fa-trash trash-color'
                                        : (products.length - 1 === key)
                                          ? 'fas fa-trash trash-color'
                                          : 'fas fa-trash trash-color'}`}
                                    onClick={() => this._onClickScanProduct(key)}
                                  />

                                </div>

                                <div className={`form-group ${(!item.isScanLot || products.length - 1 !== key) ? '' : 'fill'}`}>
                                  {
                                    item.UnitPrice !== null
                                      ? (
                                        <>
                                          <Field
                                            type="text"
                                            name={`LotNo${key}`}
                                            className={`form-control product-icon case-product-filled ${item.LotNo !== null ? 'case-product-filled' : ''} `}
                                            placeholder={`${item.isScanLot && user.scanner ? 'Scan Lot' : 'Enter Lot'} #`}
                                            component={renderField}
                                            onClick={(item.isScanLot && user.scanner)
                                              ? () => { this._onLotClick(key); }
                                              : () => { }}
                                            onBlur={(e) => { this._onEnterLot(e, key); }}
                                            disabled={item.isScanLot && (item.LotNo !== '' || item.LotNo !== null)}
                                          />
                                          <i
                                            className={`icon-right ${user.scanner && item.isScanLot ? 'fas fa-times' : 'fas fa-keyboard'}`}
                                            onClick={() => this._onClickOtherScanLot(key, item)}
                                            style={{ right: 0 }}
                                          />
                                        </>
                                      ) : (
                                        <>
                                          <Field
                                            type="text"
                                            id={`LotNo${key}`}
                                            name={`LotNo${key}`}
                                            className={`form-control product-icon case-product-filled ${item.LotNo !== null ? 'case-product-filled' : 'product-scan-border'}`}
                                            placeholder={`${item.isScanLot && user.scanner ? 'Scan Lot' : 'Enter Lot'} #`}
                                            component={renderField}
                                            onClick={(item.isScanLot && user.scanner)
                                              ? () => { this._onLotClick(key); }
                                              : () => { }}
                                            onBlur={(e) => { this._onEnterLot(e, key); }}
                                            disabled={(item.ProductNo === '') ? true : ((item.LotNo !== null) && item.isScanLot)}
                                          />
                                          <i
                                            onClick={() => this._onClickScanLot(key)}
                                            className={`icon-right lot-icon ${(item.ProductNo !== '') ? `${(item.LotNo === null)
                                              ? user.scanner && item.isScanLot
                                                ? 'fas fa-keyboard' : 'fas fa-times'
                                              : 'fas fa-times'}` : ''}`}
                                            style={{ right: 0 }}
                                          />
                                        </>
                                      )
                                  }
                                </div>

                                <div className="form-group">
                                  {
                                    item.UnitPrice !== null
                                      ? (
                                        <Field
                                          type="text"
                                          name={`RepInventoryType${key}`}
                                          className="form-control "
                                          placeholder="Amount"
                                          component={renderField}
                                          disabled={item.isOtherCharge}
                                        />
                                      )
                                      : (
                                        <Select2
                                          style={{ color: 'red' }}
                                          className="form-select form-control"
                                          data={productInventoryType.map(({ OptionName }) => (
                                            { id: OptionName, text: OptionName }))}
                                          onSelect={
                                            ({
                                              target: { value }
                                            }) => this._onChangeProductInventoryType(value, key)
                                          }
                                          value={item.RepInventoryType}
                                          options={{ placeholder: 'Select Inventory Type' }}
                                        />
                                      )
                                  }
                                </div>

                              </div>
                            )
                            : ''
                        ))
                      }
                    </div>
                  </section>

                  <section className="sets-footer-section fixed-bottom">
                    <div className="container">
                      <div className="button-block">
                        <div className="row gx-2">
                          <div className="col-12 text-center">
                            <button type="button" className="btn btn-sm btn-theme-alt btn-theme-outline-alt" onClick={this._onClearAllProduct}>Clear</button>&nbsp;
                            <button
                              type="button"
                              className={`btn btn-sm btn-theme-alt btn-theme-outline-alt ${caseRes.ProductNotes ? 'active' : ''}`}
                              onClick={this._onProductNotes}
                            >
                              Notes
                            </button>&nbsp;
                            <button
                              type="button" className="btn btn-sm btn-theme-alt btn-theme-outline-alt"
                              onClick={this._onOtherCharge}
                            >
                              Charge
                            </button>&nbsp;
                            {this.state.isFFFVisable
                              ? (
                                <button
                                  type="button" className={`btn btn-sm btn-theme-alt btn-theme-outline-alt ${this.state.isFFFActivate === 'CONFIRMED' ? 'active' : ''}`}
                                  onClick={this._onFFFCharge}
                                >
                                  FFF
                                </button>
                              ) : ''}&nbsp;

                            {
                              browserDetect === 'Safari'
                                ? (
                                  <input
                                    ref={this.uploadRef}
                                    id="uploadDGREle"
                                    accept="image/*,.pdf"
                                    type="file"
                                    capture="environment"
                                    onClick={this._onCancelUploadImage}
                                    onChange={(e) => this._onSelectImage(e.target)} className="d-none"
                                  />
                                )
                                : (
                                  <input
                                    id="uploadDGREle"
                                    accept="image/*,.pdf"
                                    type="file"
                                    capture="capture"
                                    onClick={this._onCancelUploadImage}
                                    onChange={(e) => this._onSelectImage(e.target)}
                                    className="d-none"
                                  />
                                )
                            }

                            <button
                              type="button" className="btn btn-sm btn-theme-alt btn-theme-outline-alt"
                              onClick={this._onClickDgrs}
                            >
                              DGRs: {dgrsCount}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </>
              )
          }

        </form>

        <SaveProductError
          inventoryCount={inventoryCount}
        />
        <ManuallyProductWarnModal
          onClickContinue={this._onClickContinue}
          onClickTryAgain={this._onTryAgain}
        />
        <NoProductModal
          onProductSaveYes={this._onProductSaveYes}
          onProductSaveNo={this._onProductSaveNo}
        />
        <FFFModal
          onFFFSaveYes={this._onFFFSaveYes}
          onFFFSaveNo={this._onFFFSaveNo}
        />
        <ACMProductGoBackModal
          // onSave={this._onSubmit}
          onSave={this._onProductSave}
          onCancel={this._onBackCancel}
        />
        <CaseChangesNoLonger
          id={caseRes.id}
        />
        <SaveProductModal
          onSave={this._onSubmit}
          parts={productCount}
          lotCount={lotCount}
        />
        <ClearAllProducts
          onClearAll={this._onClearAll}
        />
        <DgrRequiredModal
          onClickNo={this._onClickNoDrgRequired}
          onClickYes={this._onClickDgrs}
        />
        <VhnPpcModal
          onClickNo={this._onClickVhnPpcNoScanProduct}
          onClickYes={this._onClickVhnPpcYesScanProduct}
        />
        <VrasPpcModal
          onClickNo={this._onClickVrasPpcNoScanProduct}
          onClickYes={this._onClickVrasPpcYesScanProduct}
        />
        <ProductNotSave
          onClickYes={this._onClickProductNotSave}
          onMessage={this.state.errorMessage}
        />
        <SaveProductWastedError />
        <DeleteProductModal
          onSave={this._onDeleteProductSubmit}
        />
      </div>
    );
  }
}

const withForm = reduxForm({
  form: 'scanProductForm',
  enableReinitialize: true
});

export default withTeam(
  withTableName(
    withOtherCharge(
      withLoader(
        withLotScanner(
          withOnline(
            withNotify(
              withGoBack(
                withForm(
                  withScanner(
                    withProducts(
                      withReadOnlyProductNotes(
                        withUser(
                          withBrowserDetect(
                            AddEditProduct
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      )
    )
  )
);
